import "../styles/Header.css"; // si tienes estilos propios

function Header() {
  return (
    <header className="header">
      <a href="/" className="logo">
        <img src="https://lider.tutorandy.xyz/images/logoPw.png" alt="Logo Agencia Pretty Woman" />
        <span>Team Andy</span>
      </a>
    </header>
  );
}

export default Header;
